/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Admins.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CancelOrderAdminApiInContract,
  ErrorApiOutContract,
  MarkPrescriptionAsSentAdminApiInContract,
  PutOrdersTrackingShippedBody,
  UpdateOrderShippingAddressAdminApiInContract
} from '../pwrdbyQuickMDAdminsApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const deleteOrdersCancel = (
    cancelOrderAdminApiInContract: CancelOrderAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/orders/cancel`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cancelOrderAdminApiInContract
    },
      options);
    }
  


export const getDeleteOrdersCancelMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrdersCancel>>, TError,{data: CancelOrderAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrdersCancel>>, TError,{data: CancelOrderAdminApiInContract}, TContext> => {

const mutationKey = ['deleteOrdersCancel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrdersCancel>>, {data: CancelOrderAdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  deleteOrdersCancel(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrdersCancelMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrdersCancel>>>
    export type DeleteOrdersCancelMutationBody = CancelOrderAdminApiInContract
    export type DeleteOrdersCancelMutationError = void | ErrorApiOutContract

    export const useDeleteOrdersCancel = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrdersCancel>>, TError,{data: CancelOrderAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrdersCancel>>,
        TError,
        {data: CancelOrderAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getDeleteOrdersCancelMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putOrdersSent = (
    markPrescriptionAsSentAdminApiInContract: MarkPrescriptionAsSentAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/orders/sent`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: markPrescriptionAsSentAdminApiInContract
    },
      options);
    }
  


export const getPutOrdersSentMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrdersSent>>, TError,{data: MarkPrescriptionAsSentAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrdersSent>>, TError,{data: MarkPrescriptionAsSentAdminApiInContract}, TContext> => {

const mutationKey = ['putOrdersSent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrdersSent>>, {data: MarkPrescriptionAsSentAdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  putOrdersSent(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutOrdersSentMutationResult = NonNullable<Awaited<ReturnType<typeof putOrdersSent>>>
    export type PutOrdersSentMutationBody = MarkPrescriptionAsSentAdminApiInContract
    export type PutOrdersSentMutationError = void | ErrorApiOutContract

    export const usePutOrdersSent = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrdersSent>>, TError,{data: MarkPrescriptionAsSentAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putOrdersSent>>,
        TError,
        {data: MarkPrescriptionAsSentAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutOrdersSentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const putOrdersTrackingShipped = (
    putOrdersTrackingShippedBody: PutOrdersTrackingShippedBody,
 options?: SecondParameter<typeof fetcher>,) => {
      
      const formData = new FormData();
if(putOrdersTrackingShippedBody.file !== undefined) {
 formData.append(`file`, putOrdersTrackingShippedBody.file)
 }

      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/orders/tracking/shipped`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  


export const getPutOrdersTrackingShippedMutationOptions = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrdersTrackingShipped>>, TError,{data: PutOrdersTrackingShippedBody}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrdersTrackingShipped>>, TError,{data: PutOrdersTrackingShippedBody}, TContext> => {

const mutationKey = ['putOrdersTrackingShipped'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrdersTrackingShipped>>, {data: PutOrdersTrackingShippedBody}> = (props) => {
          const {data} = props ?? {};

          return  putOrdersTrackingShipped(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutOrdersTrackingShippedMutationResult = NonNullable<Awaited<ReturnType<typeof putOrdersTrackingShipped>>>
    export type PutOrdersTrackingShippedMutationBody = PutOrdersTrackingShippedBody
    export type PutOrdersTrackingShippedMutationError = void | ErrorApiOutContract

    export const usePutOrdersTrackingShipped = <TError = void | ErrorApiOutContract,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrdersTrackingShipped>>, TError,{data: PutOrdersTrackingShippedBody}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putOrdersTrackingShipped>>,
        TError,
        {data: PutOrdersTrackingShippedBody},
        TContext
      > => {

      const mutationOptions = getPutOrdersTrackingShippedMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update the shipping address on a pharmacy order. Blocked if an active (non-voided) label exists.
 */
export const putOrdersShippingAddress = (
    updateOrderShippingAddressAdminApiInContract: UpdateOrderShippingAddressAdminApiInContract,
 options?: SecondParameter<typeof fetcher>,) => {
      
      
      return fetcher<void>(
      {url: `https://admins-api.api.quick.md/api/v1/orders/shipping-address`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrderShippingAddressAdminApiInContract
    },
      options);
    }
  


export const getPutOrdersShippingAddressMutationOptions = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrdersShippingAddress>>, TError,{data: UpdateOrderShippingAddressAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof putOrdersShippingAddress>>, TError,{data: UpdateOrderShippingAddressAdminApiInContract}, TContext> => {

const mutationKey = ['putOrdersShippingAddress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOrdersShippingAddress>>, {data: UpdateOrderShippingAddressAdminApiInContract}> = (props) => {
          const {data} = props ?? {};

          return  putOrdersShippingAddress(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutOrdersShippingAddressMutationResult = NonNullable<Awaited<ReturnType<typeof putOrdersShippingAddress>>>
    export type PutOrdersShippingAddressMutationBody = UpdateOrderShippingAddressAdminApiInContract
    export type PutOrdersShippingAddressMutationError = ErrorApiOutContract | void

    /**
 * @summary Update the shipping address on a pharmacy order. Blocked if an active (non-voided) label exists.
 */
export const usePutOrdersShippingAddress = <TError = ErrorApiOutContract | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOrdersShippingAddress>>, TError,{data: UpdateOrderShippingAddressAdminApiInContract}, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putOrdersShippingAddress>>,
        TError,
        {data: UpdateOrderShippingAddressAdminApiInContract},
        TContext
      > => {

      const mutationOptions = getPutOrdersShippingAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    